;(function (angular, _, moment, numeral) {
  'use strict'

  angular
    .module('kilo.routes.creditnote.list')
    .controller('CreditNoteListController', CreditNoteListController)

  CreditNoteListController.$inject = [
    // Urls
    'urls',

    // Angular
    '$state', '$http', '$uibModal', '$window', '$scope',

    // Managers
    'CreditNoteManager',

    // Services
    'DatePickerService', 'SnackService', 'UtilService',
    'FilterService', 'FilterSidebarService', 'ColumnService', 'SelectionService',
    'PreferencesService', 'DisplayService', 'StatusService', 'AppAccessService',

    // Resolve
    'pagination', 'customFields', 'linkedSearch', 'referers', 'chorusStatuses'

  ]

  function CreditNoteListController (
    // Urls
    urls,

    // Angular
    $state, $http, $uibModal, $window, $scope,

    // Managers
    CreditNoteManager,

    // Services
    DatePickerService, SnackService, UtilService,
    FilterService, FilterSidebarService, ColumnService, SelectionService,
    PreferencesService, DisplayService, StatusService, AppAccessService,

    // Resolve
    pagination, customFields, linkedSearch, referers, chorusStatuses

  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    const customRangeCreatedAt = [
      {
        label: 'année dernière',
        range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
      },
      {
        label: 'mois dernier',
        range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
      },
      {
        label: 'semaine dernière',
        range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
      },
      {
        label: 'hier',
        range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
      },
      {
        label: 'aujourd\'hui',
        range: moment().range(moment().startOf('day'), moment().endOf('day'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        manager: CreditNoteManager,
        customFields: customFields,
        referers: referers,
        columns: ColumnService.getColumns('creditnote'),
        statuses: StatusService.getStatuses('creditnote'),
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        statutsCourantChorus: chorusStatuses,
        haveChorusAccess: false,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,

        // Methods
        addCriteria: addCriteria,
        archiveCreditNote: archiveCreditNote,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        getDateColor: getDateColor,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreCreditNote: restoreCreditNote,
        searchCreditNoteTitle: searchCreditNoteTitle,
        searchCreditNoteRef: searchCreditNoteRef,
        searchClients: searchClients,
        searchInvoice: searchInvoice,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchClientsNumber: searchClientsNumber
      })

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([
        () => self.columns,
        () => self.columns && self.columns.map(c => c.id + ':' + !!c.visible).join(',')
      ], updateVisibleColumns)
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(() => self.customFields, updateCustomFieldIds)
      $scope.$on('CreditNoteBulkValidate', refreshList)

      init()
    }

    function init () {
      AppAccessService.getCompanyRights().then((rights) => {
        rights.forEach((right) => {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true
        })
      })
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false)
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'))
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'))
          if (self.noFilter) {
            self.pagination.search = {}
            self.pagination.currentPage = 0
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.creditnoteList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.creditnoteList, 'pagination')
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
            }
          }
          self.selection.selectedData = []
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true
            initLinkedSearch()
          } else {
            getList()
          }
        })
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function isCustomField (key) {
      return _.includes(_.map(self.customFields, 'key'), key)
    }

    function saveColumns (changedCol) {
      let index = self.prefs.settings.creditnoteList.columns.findIndex(element => element.id === changedCol.id)
      self.prefs.settings.creditnoteList.columns[index].visible = changedCol.visible
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('creditnote')
      })
    }


    function searchClientsNumber (search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function resetColumns () {
      self.prefs.settings.creditnoteList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'))
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('creditnote')
        self.sideBarColumns = ColumnService.getColumns('creditnote')
      })
    }

    function refreshList () {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = []
      }
      self.sideBar.init()
      getList()
    }

    function initLinkedSearch () {
      if (
        linkedSearch.hasOwnProperty('status') ||
          linkedSearch.hasOwnProperty('client') ||
          linkedSearch.hasOwnProperty('label') ||
          linkedSearch.hasOwnProperty('invoiceRef')
      ) {
        self.pagination.search = {}
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) { return s.status === linkedSearch.status }))
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', { _id: linkedSearch.client, label: linkedSearch.label })
        }
        if (linkedSearch.invoiceRef) {
          if (_.isArray(linkedSearch.invoiceRef)) {
            _.each(linkedSearch.invoiceRef, function (invoice) {
              self.pagination.search = FilterService.addCriteria(self.pagination.search, 'invoiceRef', invoice)
            })
          }
        }
      } else {
        self.pagination.search = linkedSearch
      }
      getList()
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('creditnote')
      })
    }

    function archiveCreditNote (creditNote) {
      var content = "Vous êtes sur le point d'archiver cet avoir.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        creditNote.archive().then(function () {
          SnackService.snack({
            text: 'Avoir archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreCreditNote (creditNote) {
      var content = 'Vous êtes sur le point de restaurer cet avoir.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        creditNote.restore().then(function () {
          SnackService.snack({
            text: 'Avoir restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function newTab (id) {
      var url = $state.href('creditnote.show', { id: id })
      $window.open(url, '_blank')
    }

    function go (creditNote) {
      $state.go('creditnote.show', { id: creditNote })
    }

    function duplicate (creditNote) {
      CreditNoteManager.findById(creditNote._id, CreditNoteManager.query({
        populate: JSON.stringify([
          { path: 'referers' },
          { path: 'tags' }
        ])
      })).then(function (completeCreditNote) {
        PreferencesService.getPrefsFor('creditnote').then(function (prefs) {
          var dup = CreditNoteManager.create(completeCreditNote.duplicate())
          dup.origin = 'duplicate'
          $state.go('creditnote.new', { initParams: dup })
          SnackService.snack({
            text: 'Avoir dupliqué !',
            delay: 5000
          })
        })
      })
    }

    function asPdf (creditNoteId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'creditnote' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/creditnote/'
        if (template !== false) {
          url += template._id
        }
        $http.post(url, { creditNotes: [creditNoteId] }).then(
          function (d) {
            SnackService.snack({
              text: 'Avoir exporté en PDF !',
              delay: 5000
            })
          })
      })
    }

    function asCsv (creditNoteId) {
      var url = urls.backend + '/services/csv/creditnotes/'
      $http.post(url, { creditNotes: [creditNoteId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Avoir exporté en CSV !',
            delay: 5000
          })
        })
    }

    function asSpreadsheet (creditNoteId) {
      var url = urls.backend + '/services/spreadsheet/creditnotes/'
      $http.post(url, { creditNotes: [creditNoteId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Avoir exporté en feuille de calcul !',
            delay: 5000
          })
        })
    }

    function getInvoiceNumber (creditNote) {
      if (creditNote.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(creditNote, 'creditnote', creditNote.numberFormat)
    }

    function isLate (creditNote) {
      return creditNote.status !== 'paid' && moment().isAfter(moment(creditNote.dueDate))
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function getDateColor (creditNote) {
      if (creditNote.status !== 'paid') {
        if (moment().isAfter(moment(creditNote.dueDate))) {
          return 'red'
        } else if (moment(creditNote.dueDate).subtract(5, 'days') < moment()) {
          return 'orange'
        }
      }
    }

    function updateVisibleColumns () {
      self.visibleColumns = _.filter(self.columns, 'visible')
    }

    function updateCustomFieldIds () {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      const ids = Object.create(null)
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true
      })
      self.customFieldIds = ids
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    // Search mecanism

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', { _id: 'archived', value: false })
        return
      }

      var q = {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label address'
          },
          {
            path: 'tags',
            select: 'color label'
          },
          { path: 'referers' }
        ]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true)),
        select: '-stored'
      }

      var query =
        CreditNoteManager
          .query(q)
          .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }

      self.loading = true
      var promise = CreditNoteManager.post(query, { ignoreArchived: true })
      promise.then(function (data) {
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.creditNotes = _.map(data.data, function (creditNote) {
          creditNote.lastStatusDate = _.get(_.last(creditNote.history), 'date')
          return creditNote
        })
        self.loading = false
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function selectDateRange () {
      DatePickerService.getRange(self.pagination.search.date, { showRanged: true, customSelectOptions: customRanges }).then(function (dates) {
        dates.start.utcOffset(0, true)
        dates.end.utcOffset(0, true)
        addCriteria('date', dates)
        getList()
      })
    }

    function selectDueDateRange () {
      DatePickerService.getRange(self.pagination.search.dueDate, { showRanged: true, customSelectOptions: customRanges }).then(function (dates) {
        addCriteria('dueDate', dates)
        getList()
      })
    }

    function selectCreatedAtRange () {
      DatePickerService.getRange(self.pagination.search.createdAt, { showRanged: true, customSelectOptions: customRangeCreatedAt }).then(function (dates) {
        addCriteria('createdAt', dates)
        getList()
      })
    }

    function searchCreditNoteTitle (query) {
      FilterService.searchCreditNoteTitle(query).then(function (data) {
        self.titles = data
      })
    }
    function searchCreditNoteRef (query) {
      FilterService.searchCreditNoteRef(query).then(function (data) {
        self.refs = data
      })
    }

    function searchInvoice (query) {
      FilterService.searchInvoice(query).then(function (data) {
        self.invoices = data
      })
    }

    function searchClients (query) {
      if (query) {
        FilterService.searchClients(query).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchTags (query) {
      return FilterService.searchTags(query)
    }
  }
})(window.angular, window._, window.moment, window.numeral)
